export default __webpack_public_path__ + "static/mir_image-c16902942d34034a2017d6c27bcb9a40.png";